import { FC, useContext } from 'react'
import styles from './balance-button.module.scss'
import Button from '../Button'
import BalanceIcon from '@/components/icons/BalanceIcon'
import { useTranslation } from 'react-i18next'
import classNames from '@/utils/helpers/class-names.helper'
import MainModalsContext from '@/contexts/main-modals.context'

type BalanceButtonProps = {
  className?: string
}

const BalanceButton: FC<BalanceButtonProps> = ({ className }) => {
  const { t } = useTranslation()
  const { balanceModal } = useContext(MainModalsContext)

  return (
    <Button
      className={classNames(styles.button, className)}
      icon={<BalanceIcon />}
      iconClassName={styles.icon}
      onClick={() => balanceModal.setActive(true)}
    >
      {t('top-up-balance')}
    </Button>
  )
}

export default BalanceButton
